<template>
  <el-dialog
    title="Delete Orders"
    :visible.sync="shouldShow"
    width="30%"
    @close="closeEvent"
  >
    <el-row type="flex">
      <el-col :span="24">
        <p>Are you sure you want to delete the selected orders??</p>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="closeEvent">Cancel</el-button>
      <el-button type="danger" :loading="loading" @click="deleteOrders"
        >Delete</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import customer from "@/requests/customers/customer/actions";

export default {
  name: "CustomerSpecificOrdersDelete",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: [Number, String],
      default: null,
    },
    orders: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    closeEvent() {
      this.deleting = false;
      this.shouldShow = false;
    },
    deleteOrders() {
      this.deleting = true;
      const payload = {
        order_ids: this.orders,
      };
      customer
        .ordersDelete("specific", this.customerId, payload)
        .then((response) => {
          if (response.data.status) {
            this.$message.success(response.data.message);
            this.closeEvent();
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
          this.deleting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
